export class App2ConfigSettings {

    loggingLevel: string;
    envName: string;
    production: boolean;
    shouldEnforceLogin: boolean;

    constructor(
        loggingLevel: string,
        envName: string,
        production: boolean,
        shouldEnforceLogin: boolean
    ) {
        this.loggingLevel = loggingLevel
        this.envName = envName
        this.production = production
        this.shouldEnforceLogin = shouldEnforceLogin
    }

}
